import { ref } from 'vue';
import { onIFrameHostViewportChange } from '@app/embed/messages.types';

const hostScrollOffset = ref(window.scrollY);
const hostScreenViewHeight = ref(window.innerHeight);
const hostIFrameOffset = ref(0);
const hostHeight = ref(window.innerHeight);

type useModalPositioningReturn = {
  updateIFrameHostViewport: (onIFrameHostViewportChangeMessage: onIFrameHostViewportChange) => void;
  hostScrollOffset: typeof hostScrollOffset;
  hostScreenViewHeight: typeof hostScreenViewHeight;
  hostIFrameOffset: typeof hostIFrameOffset;
  hostHeight: typeof hostHeight;
};

export function useModalPositioning(): useModalPositioningReturn {
  function updateIFrameHostViewport(onIFrameHostViewportChangeMessage: onIFrameHostViewportChange) {
    hostScrollOffset.value = onIFrameHostViewportChangeMessage.scrollOffset;
    hostScreenViewHeight.value = onIFrameHostViewportChangeMessage.screenViewHeight;
    hostIFrameOffset.value = onIFrameHostViewportChangeMessage.iframeOffset;
    hostHeight.value = onIFrameHostViewportChangeMessage.hostHeight;
  }

  return {
    updateIFrameHostViewport,
    hostScrollOffset,
    hostScreenViewHeight,
    hostIFrameOffset,
    hostHeight,
  };
}
